import { db } from "@db";
import type { StorageQuotaStatus } from "@lib/storage";
import { liveQuery } from "dexie";
import { create } from "zustand";

export const useStorageStore = create<StorageQuotaStatus>((set) => {
  async function pollUsage() {
    if (!navigator.storage?.estimate) return;
    const estimate = await navigator.storage.estimate();
    set({ usage: estimate.usage ?? 0 });
  }

  pollUsage();
  setInterval(pollUsage, 5000);

  liveQuery(
    async () => (await db.settings.get("settings"))?.storageLimit ?? 0,
  ).subscribe((limit) => {
    set({ limit });
  });

  return {
    usage: 0,
    limit: 0,
    isOverQuota: false,
  };
});

useStorageStore.subscribe((state) => {
  const isOverQuota = state.limit > 0 && state.usage > state.limit;

  if (isOverQuota !== state.isOverQuota) {
    useStorageStore.setState({ isOverQuota });
  }
});
